// @flow
import { createContext } from 'react';
import type { Context } from 'react';

export const OptimizeContext: Context<{
  experiments: Array<Object>,
}> = createContext({
  experiments: [],
});
